import { Button } from "@/components/ui/button";
import useCheckout from "@/hooks/use-checkout";
import { Sparkles } from "lucide-react";

const { startSubscription } = useCheckout();

export const SubscribeBanner = () => (
    <div className="bg-orange-500 rounded-lg p-3 shadow-[inset_0px_1px_0px_0px_#FFFFFF66,0px_0px_0px_1px_#C2410CCC]">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-col md:flex-row items-center">
                <Sparkles className="h-6 w-6 mr-3 text-white" />
                <span className="font-semibold text-white">Subscribe to Start Writing.</span>
                &nbsp;
                <span className="text-white/80">Get unlimited access to all writing tasks and evaluations</span>
            </div>
            <Button
                onClick={startSubscription}
                className="bg-white hover:bg-white/90 text-orange-500"
            >
                Pay Now
            </Button>
        </div>
    </div>
);